import $ from 'jquery';

$(document).ready(function () {
  $('.home-header').removeClass('load').addClass('loaded');
});
